
<template>
    <hr v-if="card.isSeparator" class="card_item__separator" />
    <div v-else class="card_item d-flex flex-column align-items-start" :class="card.cardClass">
        <div class="d-flex card_item__title">
            <div v-if="card.image">
                <img :src="card.image" v-if="card.alt" :alt="card.alt">
                <img :src="card.image" v-if="!card.alt" alt="">
            </div> 
            <h2 v-if="headerType === 'h2'" v-html="card.text" class="card_item__header">
            </h2>       
            <h3 v-else-if="headerType === 'h3'" v-html="card.text"  class="card_item__header">
            </h3>
            <p v-else v-html="card.text"  class="card_item__header">
            </p>
        </div>
        <h3 v-if="card.descr && card.descr.length > 0 && descrType === 'h3'" class="card_item__descr"
            v-html="card.descr[0]">
        </h3>
        <p v-else-if="card.descr" class="card_item__descr">
            <span v-for="(text, index) in card.descr" :key="index" v-html="text">
            </span>
        </p>
        <ul v-if="card.list">
            <li v-for="(text, index) in card.list" :key="index" v-html="text"/>                
        </ul>
        <slot />
        <router-link class="btn" v-if="card.btn" :to="card.path" 
            :data-category="card.dataCategory" :data-label="card.dataLabel">
            {{card.btn}}
        </router-link>        
    </div>
</template>
<script>
    export default {        
        props: {
            card: {
                type: Object,
                default: {}
            },
            headerType: {
                type: String
            },
            descrType: {
                type: String
            }
        }
    }
</script>